import Fuse from 'fuse.js';
import useNavigableRoutes from './useNavigationRoutes';

const SECTION_LIMIT = 5;

/**
 * Use the input query to filter the routes.
 */
function useFilteredResults(searchQuery: string) {
  const routes = useNavigableRoutes();
  const fuse = new Fuse(routes, {
    keys: ['label', 'to'],
    isCaseSensitive: false,
  });
  const filteredResults = searchQuery ? fuse.search(searchQuery).map((result) => result.item) : routes;
  return filteredResults.slice(0, SECTION_LIMIT);
}

export default useFilteredResults;
